export let GridPinnedColumnPosition = /*#__PURE__*/function (GridPinnedColumnPosition) {
  GridPinnedColumnPosition["LEFT"] = "left";
  GridPinnedColumnPosition["RIGHT"] = "right";
  return GridPinnedColumnPosition;
}({});
export const EMPTY_PINNED_COLUMN_FIELDS = {
  left: [],
  right: []
};